;(function() {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;

  // CSS変数から in/out の継続時間をミリ秒で取得
  const parseCssDurationMs = (raw, fallbackMs) => {
    if (!raw || typeof raw !== 'string') return fallbackMs;
    const v = raw.trim();
    if (v.endsWith('ms')) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallbackMs;
    }
    if (v.endsWith('s')) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? Math.round(n * 1000) : fallbackMs;
    }
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallbackMs;
  };

  const rootStyle = getComputedStyle(document.documentElement);
  const transitionDurationIn = parseCssDurationMs(rootStyle.getPropertyValue('--preloader-duration-in'), 350);
  const transitionDurationOut = parseCssDurationMs(rootStyle.getPropertyValue('--preloader-duration-out'), 400);
  const easingVar = (rootStyle.getPropertyValue('--preloader-easing') || 'cubic-bezier(0.7, 0, 0.3, 1)').trim();

  // 内部遷移フラグ（出発→到着を滑らかに繋ぐため）
  const NEXT_FLAG_KEY = 'ag-preloader-next';
  const hasNextFlag = () => sessionStorage.getItem(NEXT_FLAG_KEY) === '1';
  const setNextFlag = () => { try { sessionStorage.setItem(NEXT_FLAG_KEY, '1'); } catch (e) {} };
  const clearNextFlag = () => { try { sessionStorage.removeItem(NEXT_FLAG_KEY); } catch (e) {} };

  // JSロード直後に、到着状態であれば即座にHTMLへクラスを付与し、CSSの初期値(150%)を適用する
  if (hasNextFlag()) {
    document.documentElement.classList.add('ag-preloader-next');
  }

  // セクション設定: data-show-once（セッション内で到着側の表示を1回に制限）
  // 連続体験重視のため、2回目以降も到着側アニメを出したい場合は isShowOnce を false に扱う
  const SHOW_ONCE_KEY = 'ag-preloader-once';
  const isShowOnceRaw = preloader.getAttribute('data-show-once') === 'true';
  const isShowOnce = false && isShowOnceRaw; // 常時シームレス優先（必要なら true に戻す）
  const hasShownOnce = () => sessionStorage.getItem(SHOW_ONCE_KEY) === '1';
  const setShownOnce = () => { try { sessionStorage.setItem(SHOW_ONCE_KEY, '1'); } catch (e) {} };

  const showEntering = (addEntering = true) => {
    preloader.style.display = 'flex';
    preloader.classList.remove('is-hidden', 'is-exiting', 'is-entering');
    // レイアウト確定
    void preloader.offsetWidth;
    if (addEntering) {
      preloader.classList.add('is-entering');
    }
  };

  const startExit = () => {
    preloader.style.transition = '';
    
    preloader.classList.remove('is-entering');
    // reflow を入れてから is-exiting を付与して確実にトランジションを発火
    void preloader.offsetWidth;
    preloader.classList.add('is-exiting');
    setTimeout(() => {
      preloader.classList.add('is-hidden');
      preloader.style.display = 'none';
      preloader.classList.remove('is-entering', 'is-exiting');
      document.documentElement.classList.remove('ag-preloader-next');
    }, transitionDurationOut);
  };

  // 到着側：内部遷移時のみ短く表示→退場（外部流入・リロードでは表示しない）
  window.addEventListener('DOMContentLoaded', () => {
    if (hasNextFlag() && !(isShowOnce && hasShownOnce())) {
      clearNextFlag();
      showEntering(false);
      
      // 動的待機：画像の完全読み込みに連動させる
      let isExited = false;
      const doExit = () => {
        if (isExited) return;
        isExited = true;
        // 最初の状態（画面が円で塞がっている状態）がブラウザに描画される時間を確保してから退場アニメを発火させる
        setTimeout(() => {
          startExit();
          if (isShowOnce) setShownOnce();
        }, 100);
      };

      if (document.readyState === 'complete') {
        doExit();
      } else {
        window.addEventListener('load', doExit);
        // セーフティネット：通信障害等で画像が永遠に読み込まれない場合のフォールバック（最大2.5秒で強制解除）
        setTimeout(doExit, 2500);
      }
    } else {
      preloader.classList.add('is-hidden');
      preloader.style.display = 'none';
    }
  });

  // 出発側：内部リンククリック時に表示→既定時間後に遷移
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');

    // カートドロアーを開くトリガーや、ページ遷移を伴わない非同期処理（カート内の削除など）ではプリローダーを発動しない
    if (
      link.id === 'cart-icon' ||
      link.classList.contains('js-open-cart-drawer') ||
      link.classList.contains('js-remove-item') ||
      (href && (href.includes('/cart/change') || href.includes('/cart/add') || href.includes('/cart/update')))
    ) {
      return;
    }

    const isBlank = link.target === '_blank';
    const isAnchor = href && href.startsWith('#');
    const isProtocol = href && (href.startsWith('mailto:') || href.startsWith('tel:'));
    const isDownload = link.hasAttribute('download');
    const isExternal = link.hostname !== window.location.hostname;

    if (!href || href === '' || isBlank || isAnchor || isProtocol || isDownload || isExternal) {
      return;
    }

    event.preventDefault();

    setNextFlag();

    // 出発時: インラインで確実にトランジションを発火
    preloader.style.display = 'flex';
    preloader.style.transition = 'none';
    
    preloader.classList.remove('is-hidden', 'is-exiting');
    preloader.classList.remove('is-entering');
    // reflow
    void preloader.offsetWidth;
    requestAnimationFrame(() => {
      preloader.style.transition = '';
      preloader.classList.add('is-entering');
    });

    // 動的対応：最低限の描画フレーム(50ms)のみ確保し、即座に遷移(通信)を開始して無駄な待機時間を無くす
    setTimeout(() => { window.location.href = href; }, transitionDurationIn);
  });

  // 3. ブラウザの「戻る/進む」ボタンの処理 (bfcache対策)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      preloader.style.transition = 'none';
      preloader.classList.remove('is-entering', 'is-exiting', 'is-hidden');
      preloader.style.display = 'none';
      requestAnimationFrame(() => {
        preloader.style.transition = '';
      });
    }
  });

  // フォーム送信側の監視: 検索機能への対応
  document.addEventListener('submit', (event) => {
    const form = event.target;
    // 検索フォームである場合のみ発火 (Actionが存在し、かつ /search を含む場合)
    if (form.action && form.action.includes('/search')) {
      event.preventDefault();
      setNextFlag();

      preloader.style.display = 'flex';
      preloader.style.transition = 'none';
      preloader.classList.remove('is-hidden', 'is-exiting', 'is-entering');
      void preloader.offsetWidth;
      requestAnimationFrame(() => {
        preloader.style.transition = '';
        preloader.classList.add('is-entering');
      });

      // Cinematicフェードアウトが完全に覆いかぶさる時間を待ってからSubmitする
      setTimeout(() => { form.submit(); }, transitionDurationIn);
    }
  });

})();